import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';

import 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorRebateStandardRate/CalculatorRebateStandardRate.scss';

const CalculatorRebateStandardRate = ({ stdRebate }) => {
    if (stdRebate <= 0) {
        return null;
    }
    return (
        <div className="payment-calculator__std-rate">
            <icon className="icon-Warning is-warning" />
            <p className="is-light">{LocaleService.t('PAYMENT_CALCULATOR.STD_REBATE', { stdRebate })}</p>
        </div>
    );
};

CalculatorRebateStandardRate.propTypes = {
    stdRebate: PropTypes.number,
};

CalculatorRebateStandardRate.displayName = 'CalculatorRebateStandardRate';

export default CalculatorRebateStandardRate;
